export const contractTypeOptions = [
  { id: 0, value: 'indefinite', label: 'Indefinido' },
  { id: 1, value: 'fixed_term', label: 'Plazo fijo' },
  { id: 2, value: 'work_or_task', label: 'Por obra o faena' }
]
